import { useState, type ReactNode } from "react";
import { MoonStar, Heart } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import lunaBandanaAsset from "@/assets/luna-bandana.jpg.asset.json";
import { cn } from "@/lib/utils";

export function LunaStoryModal({
  className,
  children,
}: {
  className?: string;
  children?: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex items-center gap-2 text-sm font-extrabold transition-colors",
            className,
          )}
        >
          <MoonStar className="h-4 w-4" aria-hidden />
          {children ?? "Conoce la historia de Luna 🌙"}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-lg gap-0 overflow-hidden rounded-[1.75rem] border-none bg-night p-0 text-night-foreground">
        <img
          src={lunaBandanaAsset.url}
          alt="Luna, una perrita negra con pañuelo rojo, sonriendo a la cámara"
          className="h-48 w-full object-cover"
          width={1024}
          height={1024}
          loading="lazy"
          decoding="async"

        />
        <div className="px-6 pb-7 pt-5 sm:px-8">
          <DialogHeader className="space-y-2 text-left">
            <DialogTitle className="font-display text-2xl font-bold text-accent">
              La historia de Luna 🌙
            </DialogTitle>
            <DialogDescription className="text-night-foreground/75">
              El corazón detrás de cada viaje PetMoon.
            </DialogDescription>
          </DialogHeader>

          <div className="mt-4 space-y-4 text-sm leading-relaxed text-night-foreground/80 sm:text-base">
            <p>
              PetMoon nació del amor incondicional por mi perrita{" "}
              <strong className="font-extrabold text-accent">Luna</strong>. Ella me enseñó
              que nuestras mascotas no son solo animales: son familia.
            </p>
            <p>
              Cuando Luna nos dejó, decidí transformar ese amor en un propósito: que cada
              peludo viaje con el mismo cuidado, seguridad y cariño que yo le daría a ella.
              Con arnés, higiene total y manos que entienden lo que significa tu compañero.
            </p>
          </div>

          <p className="mt-6 inline-flex items-center gap-2 font-display text-base font-bold text-accent">
            <Heart className="h-4 w-4" fill="currentColor" aria-hidden />
            Cada viaje es guiado por la luz de Luna.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
